import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const ResourcesTabs = ({ tabs, loading, toggleTab, activeTab }) => {
  return (
    <Nav
      className="nav-tabs-custom mt-2 mb-3 ms-0 card-header-tabs border-bottom-0  "
      role="tablist"
    >
      {tabs.map((tab) => (
        <NavItem key={tab.id}>
          <NavLink
            className={classnames(
              {
                active: activeTab === tab.id,
                disabled: loading,
                "fw-semibold": activeTab === tab.id,
              },
              "p-2 text-primary"
            )}
            onClick={(e) => {
              if (loading) {
                e.preventDefault();
              } else {
                toggleTab(tab.id, tab.name);
              }
            }}
            href="#"
          >
            {tab.label}
          </NavLink>
        </NavItem>
      ))

      }



    </Nav>
  );
};

export default ResourcesTabs;
